<template>
  <v-col class="justify-center body-1">
    <v-row>
      <div class="title">{{ $t("Name") }}</div>
    </v-row>
    <v-row justify="space-between" align="center">
      <v-text-field
        v-model="settings.name"
        :counter="30"
        :label="$t('Establishment name')"
        :rules="[value => (value ? true : $t('This field is required'))]"
      />
    </v-row>

    <v-row class="d-flex flex-column">
      <div class="title mt-8">{{ $t("Payment options") }}</div>
    </v-row>
    <v-row justify="space-between" align="center">
      <div>{{ $t("Accept cash payment") }}</div>
      <v-switch v-model="settings.cash" />
    </v-row>
    <v-row justify="space-between" align="center">
      <div>{{ $t("Accept credit card payment") }}</div>
      <v-switch v-model="settings.card" />
    </v-row>

    <v-row class="d-flex flex-column">
      <div class="title mt-8">{{ $t("QR options") }}</div>
    </v-row>
    <v-row justify="space-between" align="center">
      <div>{{ $t("Show logo in QR") }}</div>
      <v-switch v-model="settings.qrLogo" />
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: ["settings"]
};
</script>

<style></style>
